import type { PublicPathState, InputBindsConfig, LazyInputBindsConfig } from 'vee-validate';

export function useFormValidation() {
    
    const ComponentBindsConfigs = {
        vuetify(state: PublicPathState) {
            return {
                props: {
                    'error': !!state.errors.length,
                    'error-messages': state.errors,
                }
            };
        }
    }

    function getDefineFieldOptions(
        type: keyof typeof ComponentBindsConfigs,
        opts: Partial<InputBindsConfig | LazyInputBindsConfig> = {}
    ): Partial<InputBindsConfig | LazyInputBindsConfig> {
        
        return (state: PublicPathState) => ({
            ...opts,
            ...ComponentBindsConfigs[type](state)
        });
    }

    return {
        ComponentBindsConfigs,
        getDefineFieldOptions
    };
}

